import api from '../api';

// Add a response interceptor to handle 401 errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if the error is a 401 Unauthorized response
    if (error.response && error.response.status === 401 && !error.config.url.includes('/auth/login')) {
      // Redirect to the login page
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const login = (email, password) => {
  const formData = new FormData();
  formData.append('username', email);
  formData.append('password', password);
  return api.post('/auth/login', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getUsers = (nextPageId, pageSize = 10, search = '') => {
  let url = `/users?page_size=${pageSize}`;
  if (nextPageId) {
    url += `&start_after=${nextPageId}`;
  }
  if (search) {
    url += `&search=${search}`;
  }
  return api.get(url);
};

export const getNotifications = (userId, pageId) => {
  const url = `/users/${userId}/notifications?page_size=100${pageId ? `&page_id=${pageId}` : ''}`;
  return api.get(url);
};

export const getTransactions = (userId) => {
  return api.get(`/users/${userId}/transactions?page_size=20`);
};

export const getDashboardStats = () => {
  return api.get('/users/stats');
};

export const getUsersByDateRange = (startDate, endDate) => {
  return api.get(`/users/by_date_range?start_date=${startDate}&end_date=${endDate}&activity_type=registration_activity`);
};

export const getUserActivityByDateRange = (startDate, endDate) => {
  return api.get(`/users/by_date_range?start_date=${startDate}&end_date=${endDate}&activity_type=login_activity`);
};

export const getEmailStats = () => {
  return api.get('/emails/stats');
};

export const sendBroadcastNotification = (payload) => {
  return api.post('/notifications/broadcast', payload);
};

export const getNotificationHistory = (page = 1, pageSize = 10) => {
  const safePage = Number.isFinite(Number(page)) && Number(page) > 0 ? Number(page) : 1;
  return api.get(`/notification/history?page=${safePage}&page_size=${pageSize}`);
};
